import React from 'react'
import styled from 'styled-components'

const LogoContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
`

const LogoImage = styled.img`
  width: 32px;
  height: 32px;
  object-fit: contain;
`

const LogoText = styled.span`
  font-size: 1.5rem;
  font-weight: 700;
  color: inherit;
`

export default function Logo({ showText = true }) {
  return (
    <LogoContainer>
      <LogoImage src="/logo.png" alt="OmniBrain Logo" />
      {showText && <LogoText>OmniBrain</LogoText>}
    </LogoContainer>
  )
}
